import { FluentBundle } from '@fluent/bundle';

function makeBundle(locale, ftl) {
  const bundle = new FluentBundle(locale, { useIsolating: false });
  bundle.addMessages(ftl);
  return bundle;
}

export async function getTranslator(locale) {
  const bundles = [];
  
  // 1. Ép locale luôn là 'vi' nếu bạn muốn cố định, 
  // hoặc dùng 'vi' làm mặc định nếu locale truyền vào bị trống.
  const targetLocale = 'vi'; 

  // 2. Load file Tiếng Việt làm ưu tiên số 1
  try {
    const { default: viftl } = await import(`../public/locales/vi/send.ftl`);
    bundles.push(makeBundle('vi', viftl));
  } catch (err) {
    console.error("Cảnh báo: Không tìm thấy file tiếng Việt tại locales/vi/send.ftl");
  }

  // 3. Load file Tiếng Anh để làm dự phòng (fallback) 
  // (Chỉ dùng khi một số từ khóa trong file VN chưa được dịch)
  try {
    const { default: en } = await import('../public/locales/en-US/send.ftl');
    bundles.push(makeBundle('en-US', en));
  } catch (err) {
    // Không tìm thấy en-US cũng không sao nếu vi đã có
  }

  return function(id, data) {
    for (let bundle of bundles) {
      if (bundle.hasMessage(id)) {
        return bundle.format(bundle.getMessage(id), data);
      }
    }
    return id; // Trả về chính cái ID nếu không tìm thấy dịch thuật ở cả 2 file
  };
}
